const API_BASE = '/api'

interface SlideResponseParams {
  sessionId: string
  slideIndex: number
  slideTitle: string
  responseType: string
}

interface WaitlistParams {
  sessionId: string
  name: string
  email: string
  firmName?: string
  firmSize?: string
  phone?: string
}

interface NoFeedbackParams {
  sessionId: string
  slideIndex: number
  slideTitle: string
  currentSolution?: string
}

export async function recordSlideResponse(params: SlideResponseParams): Promise<Response> {
  return fetch(`${API_BASE}/public/validation/slide-response`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      session_id: params.sessionId,
      slide_index: params.slideIndex,
      slide_title: params.slideTitle,
      response_type: params.responseType,
    }),
  })
}

export async function joinWaitlist(params: WaitlistParams): Promise<Response> {
  return fetch(`${API_BASE}/public/validation/waitlist`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      session_id: params.sessionId,
      name: params.name,
      email: params.email,
      firm_name: params.firmName,
      firm_size: params.firmSize,
      phone: params.phone,
    }),
  })
}

export async function submitNoFeedback(params: NoFeedbackParams): Promise<Response> {
  return fetch(`${API_BASE}/public/validation/no-feedback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      session_id: params.sessionId,
      slide_index: params.slideIndex,
      slide_title: params.slideTitle,
      current_solution: params.currentSolution,
    }),
  })
}
